import { getParamKey } from '../../_data/getParamKey';
import { QuestionMethods } from '../questionMethods.types';
import {
	RenderedMultipleSelectQuestion,
	MultipleSelectGivenAnswer,
} from './multipleSelectMethods.types';

export const addMultipleSelectToSearchParams: QuestionMethods<
	RenderedMultipleSelectQuestion,
	MultipleSelectGivenAnswer
>['addToSearchParams'] = ({ searchParamsDraft, question, givenAnswers }) => {
	const answer = givenAnswers.multiple.get(question.id);
	if (answer != null) {
		const paramKey = getParamKey(question.id);
		if (answer.size === 0) {
			searchParamsDraft.set(paramKey, '');
		} else {
			for (const entry of answer) {
				searchParamsDraft.append(paramKey, entry);
			}
		}
	}
};

export const addMultipleSelectToGivenAnswers: QuestionMethods<
	RenderedMultipleSelectQuestion,
	MultipleSelectGivenAnswer
>['addToGivenAnswers'] = ({ givenAnswersDraft, searchParams, question }) => {
	const answers = searchParams.getAll(getParamKey(question.id));

	if (answers.length > 0) {
		if (answers.length === 1 && answers[0] === '') {
			givenAnswersDraft.multiple.set(question.id, new Set());
		} else {
			givenAnswersDraft.multiple.set(question.id, new Set(answers));
		}
	}
};
